import React, { useState } from 'react';
import AudioRecorder from './AudioRecorder';
import './TranscriptionDemo.css';
import { getApiBaseUrl } from '../config';

function TranscriptionDemo({ isLoading }) {
  const [transcriptions, setTranscriptions] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(null);
  const [latestTranscript, setLatestTranscript] = useState('');

  const handleAudioUpload = async (audioBlob) => {
    // Check if audio blob has data
    if (audioBlob.size === 0) {
      return;
    }

    setError(null);

    try {
      const formData = new FormData();
      formData.append('audio', audioBlob, 'audio.wav');

      const apiUrl = getApiBaseUrl();
      const response = await fetch(`${apiUrl}/api/transcribe-only`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Transcription failed');
      }

      const data = await response.json();
      
      // Only add non-empty transcriptions to the list
      if (data.transcript && data.transcript.trim().length > 0) {
        setTranscriptions(prev => [...prev, data.transcript]);
        setLatestTranscript(data.transcript);
      } else {
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const clearTranscriptions = () => {
    setTranscriptions([]);
    setLatestTranscript('');
    setError(null);
  };

  return (
    <div className="transcription-demo">
      <div className="transcription-recorder">
        <AudioRecorder
          onAudioReady={handleAudioUpload}
          isLoading={isLoading}
          onListeningChange={setIsListening}
        />
      </div>

      {error && <div className="transcription-error">{error}</div>}

      {latestTranscript && (
        <div className="transcription-latest">
          <h3>Latest Transcription:</h3>
          <div className="transcription-text">{latestTranscript}</div>
        </div>
      )}

      <div className="transcription-logs-box">
        <div className="transcription-history">
          <div className="transcription-header">
            <h3>All Transcriptions ({transcriptions.length})</h3>
            {transcriptions.length > 0 && (
              <button onClick={clearTranscriptions} className="clear-button">Clear</button>
            )}
          </div>
          
          {transcriptions.length > 0 ? (
            <div className="transcription-list">
              {transcriptions.map((transcript, index) => (
                <div key={index} className="transcription-item">
                  <span className="transcript-number">{index + 1}.</span>
                  <span className="transcript-text">{transcript}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="transcription-empty">
              {isListening ? 'Listening for speech...' : 'Click the microphone to start transcribing'}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default TranscriptionDemo;